export default "__VITE_ASSET__07a9f25e__"